exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.fade-enter-active[data-v-74bdc4f0],\n.fade-leave-active[data-v-74bdc4f0] {\n\t-webkit-transition: opacity 0.5s;\n\ttransition: opacity 0.5s;\n}\n.fade-enter[data-v-74bdc4f0],\n.fade-leave-to[data-v-74bdc4f0] {\n\topacity: 0;\n}\n.header[data-v-74bdc4f0] {\n\tposition: fixed;\n\ttop: 0;\n\tz-index: 100;\n}\n.appTop[data-v-74bdc4f0] {\n\tpadding-top: 115px;\n}\n@media (max-width: 768px) {\n.appTop[data-v-74bdc4f0] {\n\t\tpadding-top: 65px;\n}\n}\n", ""]);

// exports
